import './style.scss';

import { PageLocationSP } from 'views/components/atoms/pageLocation';
import { Button, ButtonSize, FillType } from 'views/components/atoms/button';
import { List } from 'views/components/organisms/list';
import { DocumentGrandHeaderShowList } from 'views/constants/const/DocumentGrant';
import { Pagination } from 'views/components/atoms/pagination';
import { SearchSelect } from 'views/components/atoms/searchSelect';
import { useDocumentGrant } from './hooks';
import { Toast } from 'views/components/atoms/toast';

export const DocumentGrant = () => {
  const {
    documentList,
    selectedDocumentType,
    selectDocumentType,
    bodyShowLists,
    paginationData,
    handleDownload,
    listLoading,
    toastProps,
  } = useDocumentGrant();

  return (
    <section className="outletWrapper">
      <PageLocationSP />
      <div className="centerContent">
        <div className="downloadNav">
          <SearchSelect
            selectedOption={selectedDocumentType}
            setSelectedOption={(value) => selectDocumentType(value)}
            options={documentList.map((x) => x.key)}
          />
          <Button
            label="選択したPDFをダウンロード"
            fillType={FillType.primaryFill}
            buttonSize={ButtonSize.sizeM}
            onClick={() => {
              handleDownload();
            }}
          />
        </div>
        <List headerShowList={DocumentGrandHeaderShowList} bodyShowLists={bodyShowLists} loading={listLoading} />
        <Pagination {...paginationData} />
      </div>
      <Toast {...toastProps} />
    </section>
  );
};
